import './homepage.css';
import './viewAllStakeholders.css';
import React, { useState, useEffect } from "react";

import { GET_STAKEHOLDERS_BY_CRITERIA, ACTIVATE_STAKEHOLDERS, GET_USER_DETAILS } from '../../common/URLs';
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate, useLocation } from "react-router-dom";
import { Container, Row, Col } from 'react-bootstrap';
import { getLocalStorageItem } from '../../common/localStorageUtils';
import jwt from 'jwt-decode';
import { Box, CardContent, Card, Typography, Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { KeyboardArrowLeftRounded } from '@mui/icons-material'
import { Link as RouterLink } from 'react-router-dom';
import { Fab } from '@mui/material';
import { PROD } from "../../common/constants";
import Link from "@mui/material/Link";
import { QuickSearchToolbar } from '../../payment/common/commonFunctions';
import { loaderService } from '../../common/custom-loader/loader-service';
import { lastFiveDigitsComparator } from '../../common/commonFunction';
import { useTranslation } from 'react-i18next';
import { Switch } from 'antd';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import { toast } from 'react-toastify';
import apiClient from '../../axios';

function ViewAllStakeholders() {
    const { t } = useTranslation();
    const [stakeHolders, setStakeHolders] = useState();
    const [emailId, setEmailId] = useState();
    const [userDetails, setUserDetails] = useState();
    const [details, setDetails] = useState({
        urn: '',
        isActive: true,
    });
    const location = useLocation();
    const userId = location?.state?.userId;
    let status = location?.state?.status;

    const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
    const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
    const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);

    let herderText = "Active Applications";
    if (userId) herderText = "Pre Registrations";

    else if (status == "Shortlisted") {
        herderText = "Shortlisted Stakeholders";
    }
    else if (status == "Waitlisted") {
        herderText = "Waitlisted Stakeholders";
    }
    else if (status == "Pre_Registration_Initiated") {
        herderText = "New Registrations";
    }
    else if (status == "Inactive") {
        herderText = "Inactive Applications";
    }
    useEffect(() => {
        getAllStakeholders(status, userDetails);
    }, [status, userDetails]);

    const viewURNDetails = (urn) => {
        navigate("/registrationHome/dashboard/viewPageWraper", { state: { urn: urn, status: status, goBack: true } });
    }
    useEffect(() => {
        if (getLocalStorageItem('id_token')) {
            const decoded = jwt(getLocalStorageItem('id_token'));
        }
    }, [getLocalStorageItem('id_token')]);
    useEffect(() => {
        if (getLocalStorageItem('id_token')) {
            const decoded = jwt(getLocalStorageItem('id_token'));
            const email = decoded.emails?.[0];
            setEmailId(email);

        }
    }, [getLocalStorageItem('id_token')]);

    useEffect(() => {
        // if (emailId) {
        getUserDetails();
        // }
    }, [emailId]);

    function onConfirmCallBack() {
        handleConfirmLogModalClose();
        if (details) {
            updateStakeholders();
        }
    }
    function updateStakeholders() {
        loaderService.showLoader();
        var activateStk = {
            "urn": details?.urn,
            "isActive": details?.isActive,

        };
        var arrStk = [];
        arrStk.push(activateStk);

        apiClient
            .post(ACTIVATE_STAKEHOLDERS,
                {
                    "stakeHolderList": arrStk
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                },
            )
            .then((response) => {
                loaderService.hideLoader();
                details?.isActive == true? toast.success("Stakeholder activated successfully") : toast.success("Stakeholder deactivated successfully");
                getAllStakeholders(status);
            })
            .catch(function (error) {
                loaderService.hideLoader();
                console.log(error);
            });
    }
    function getUserDetails() {
        loaderService.showLoader()
        apiClient
            .post(GET_USER_DETAILS,
                {
                    "emailAddress": emailId,
                    // "userRole": localStorage.getItem('role'),
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setUserDetails(response.data.user);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                loaderService.hideLoader();
            });
    }
    // console.log("userDetails", userDetails?.userRoles
    // ?.[0]?.userId)
    function getAllStakeholders(status) {
        loaderService.showLoader();
        if (status == "All") {
            status = "active_applications";
        }
       else if (status == "Inactive") {
            status = "inactive_applications";
        }
        apiClient
            .post(GET_STAKEHOLDERS_BY_CRITERIA,
                {
                    "status": status ? status : "",
                    "createdBy": userId
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setStakeHolders(response.data);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                loaderService.hideLoader();
            });
    }

    const stakeHoldersArray = stakeHolders?.stakeHolders;

    const navigate = useNavigate();

    const onToggleClick = (e, params) => {
        if (params?.isActive === 1) {
            setDetails({ ...details, urn: params.urn, isActive: 2 })
        }
        else {
            setDetails({ ...details, urn: params.urn, isActive: 1 })
        }
        handleConfirmLogModalOpen();
    }

    const columns = [
        {
            field: 'id', headerName: 'S.No', width: 60,
            renderCell: (index) => index.api.getRowIndex(index.row.id) + 1
        },
        {
            field: 'name', headerName: t('preReg.name'), width: 180,
            renderCell: (params) => (
                <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', width: '100%' }}>
                    {params.row.subCategory && params.row.subCategory.toLowerCase() == "individual" ? (params.row.contactPersonFirstname + (params.row.contactPersonMiddlename ? " " + params.row.contactPersonMiddlename : "") + " " + params.row.contactPersonLastname) : params.row.name}
                </div>
            ),
            valueGetter: (params) => params.row.subCategory && params.row.subCategory.toLowerCase() == "individual" ? (params.row.contactPersonFirstname + (params.row.contactPersonMiddlename ? " " + params.row.contactPersonMiddlename : "") + " " + params.row.contactPersonLastname) : params.row.name
         },
        {
            field: 'urn', headerName: 'URN', width: 150,
            sortComparator: (a, b) => lastFiveDigitsComparator(a, b), renderCell: (params) => { return (<Link to={params} onClick={() => { viewURNDetails(params?.row?.urn) }}>{params.value}</Link>) }
        },
        { field: 'categoryName', headerName: 'Stakeholder Type', width: 180 },
        { field: 'subCategory', headerName: 'Stakeholder Subcategory', width: 180 },
        { field: 'registrationStatus', headerName: 'Status', width: 150 },
        { field: 'lastUpdatedDate', headerName: 'Last Updated Date', width: 180 },
        {
            field: 'isActive', headerName: 'Active', width: 100,
            renderCell: (params) => {
                return (
                    <Switch
                        checked={params?.row?.isActive === 1 ? true : false}
                        checkedChildren="Yes"
                        unCheckedChildren="No"
                        onClick={(e) => onToggleClick(e, params?.row)}
                    />
                )
            }
        },
    ];

    return (
        <>
            {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG42</p>}
            <Card>
                <CardContent>
                    <div style={{ display: "inline-flex" }}>
                        <Typography variant="h4" sx={{ mb: 2 }}>
                            {/* <Fab component={RouterLink} to='../dashboard' size="small" aria-label="back" title='Back'> */}
                            <Fab onClick={() => { navigate(-1) }} size="small" aria-label="back" title='Back'>
                                <KeyboardArrowLeftRounded />
                            </Fab>
                        </Typography>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <div className="hitDetailsText">{herderText}</div>
                    </div>
                    {stakeHoldersArray &&
                        <Box style={{ height: 500, width: '100%', marginTop: "2vh" }}>
                            <DataGrid sx={{
                                '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '6px' },
                                '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '12px' },
                                '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '18px' },
                            }}
                                getRowHeight={() => 'auto'}
                                rows={stakeHoldersArray}
                                columns={columns}
                                pageSize={10}
                                getRowId={(row) => row?.id}
                                components={{ Toolbar: QuickSearchToolbar }}
                            />
                        </Box>}
                </CardContent>
            </Card>
            <ConfirmationPopover onConfirm={onConfirmCallBack} onOpen={logConfirmModalOpen} action="Submit" onClose={handleConfirmLogModalClose} />
        </>
        // <div>
        //     <Container fluid>
        //         <Row>
        //             {/* <Col xs={12} md={3}>
        //                 <div className="viewall-sidebar-container">
        //     <ArrowBackIosNew className="arrow-icon" onClick={() => (navigate(-1))} />
        //                 </div></Col> */}
        //             <Col xs={12} md={12}>
        //             {!PROD &&   <p style={{ textAlign: "center", fontSize: "2vh" }}>REG42</p>}

        //           <div style={{display : "inline-flex"}}> <Typography variant="h4" sx={{ mb: 2 }}>
        //             <Fab component={RouterLink} to='../dashboard' size="small" aria-label="back" title='Back'>
        //             <KeyboardArrowLeftRounded />
        //             </Fab>
        //         </Typography>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        //     <div className="hitDetailsText">{herderText}</div> </div> 
        //     <div className="table-wrap">
        //         <table className="table-view-class">
        //             <tr className='tr trStyle'>
        //                 <th className='th colorBlack'>S.No</th>
        //                 <th className='th colorBlack'>Name</th>
        //                 <th className='th colorBlack'>URN</th>
        //                 <th className='th colorBlack'>Stakeholder Type</th>
        //                 <th className='th colorBlack'>Status</th>
        //                 {/* <th className='th'>Action</th> */}
        //             </tr>
        //             {stakeHoldersArray && stakeHoldersArray.map((item, index) => {
        //                 return (
        //                     <tr className='tr' key={index}>
        //                         <td className='td'>{index + 1}</td>
        //                         <td className='td'>{item?.name}</td>
        //                         <td className='td'><a onClick={(e) => viewURNDetails(item.urn)} style={{ color: "blue", textDecoration: "underline" }}>{item.urn}</a></td>
        //                         <td className='td'>{item?.categoryName}</td>
        //                         <td className='td'>{item?.registrationStatus}</td>
        //                         {/* <td className='td'><button className='view-btn'>View</button></td> */}
        //                     </tr>
        //                 )
        //             })}
        //         </table>
        //                 </div>
        //             </Col>
        //         </Row>
        //     </Container>
        // </div>
    );
}
export default ViewAllStakeholders;

